import { render, staticRenderFns } from "./Orcamento.vue?vue&type=template&id=9332092c&"
import script from "./Orcamento.vue?vue&type=script&lang=js&"
export * from "./Orcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports